import React, { useState } from "react";
import { DivColumn, ParagraphText } from "../../../styles/SharedStyles";
import ConstantsTexts from "../../../constants/ConstantsTexts";
import "./WidgetAlertDialogSubjectiveChangeReason.css";

const WidgetAlertDialogSubjectiveChangeReason = ({ onCancel, onApprove }) => {
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleApprove = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      await onApprove(reason);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="alert-dialog-subjective-change-overlay" onClick={isSubmitting ? undefined : onCancel}>
      <DivColumn className="alert-dialog-subjective-change-reason" onClick={(event) => event.stopPropagation()}>
        <ParagraphText className="alert-dialog-subjective-change-reason-message">{ConstantsTexts.CODE_262}</ParagraphText>

        <textarea
          className="alert-dialog-subjective-change-reason-textarea"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          placeholder={ConstantsTexts.CODE_263}
          rows={5}
          disabled={isSubmitting}
        />

        <div className="alert-dialog-subjective-change-reason-actions">
          <button type="button" className="alert-dialog-subjective-change-reason-cancel" onClick={onCancel} disabled={isSubmitting}>
            <ParagraphText className="alert-dialog-subjective-change-reason-cancel-text">{ConstantsTexts.CODE_7}</ParagraphText>
          </button>
          <button type="button" className="alert-dialog-subjective-change-reason-approve" onClick={handleApprove} disabled={isSubmitting}>
            <ParagraphText className="alert-dialog-subjective-change-reason-approve-text">{ConstantsTexts.CODE_266}</ParagraphText>
          </button>
        </div>
      </DivColumn>
    </div>
  );
};

export default WidgetAlertDialogSubjectiveChangeReason;